/**
 * Calculates the maximum height of an element based on the number of items of the Advanced Select's Popper.
 *
 * @param {number} items - The number of items.
 * @returns {string} The maximum height in pixels.
 */
export function maxHeight(items = 5) {
	const heightFactor = 25.75;
	const height = heightFactor * items + 4;
	return `${height}px`;
}
